import * as React from 'react';
import OrderTypes from '../OrderTypes';

const Dashboard = () => {
  return <OrderTypes />;
};

export default Dashboard;
